var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DatePicker from '@/shared/components/input/DatePicker';
import { TaskTemplateSelect } from '@/shared/components/input/filterInputs/FilterTaskTemplateSelect';
import RelationSearch from '@/shared/components/input/RelationSearch';
import UserSearch from '@/shared/components/input/UserSearch';
import OkCancelModal from '@/shared/components/OkCancelModal';
import { retrieveResources } from '@/shared/components/registration/resourceApi';
import ResourceAutoComplete from '@/shared/components/registration/ResourceAutoComplete';
import { useCreatePlannedTask } from '@/shared/hooks/task/useCreatePlannedTask';
import { useDataContext } from '@/shared/providers/DataProvider';
import AuthService from '@/shared/services/AuthService';
import { falseFunc, isBeforeMinimum } from '@/shared/utils/validationHelpers';
import classNames from 'classnames';
import moment from 'moment';
import { createRef, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import Toggle from 'react-toggle';
import guid from '@/shared/utils/guid';
import { InvoiceStreamSelect } from '@/shared/components/input/InvoiceStreamSelect';
import { TaskTagsMultiSelect } from '@/shared/components/input/multiselect/TaskTagsMultiSelect';
import messages from './taskMessages';
import { getFirstSelectedInvoiceStream, } from '@/shared/components/registration/registrationHelpers';
var defaultTask = {
    taskLevel: 2,
    name: '',
    remark: '',
    deadline: moment(),
    userId: guid.empty,
    relation: undefined,
    invoiceStreamId: undefined,
    tags: [],
};
var CreateOneTimeTask = function (_a) {
    var _b;
    var onSave = _a.onSave, onClose = _a.onClose, _c = _a.show, show = _c === void 0 ? false : _c, _d = _a.users, usersFromProps = _d === void 0 ? null : _d, _e = _a.relationId, initialRelationId = _e === void 0 ? null : _e;
    var intl = useIntl();
    var _f = useDataContext(), defaultCompany = _f.defaultCompany, usersFromDataCache = _f.users;
    var appendUserFromTaskTemplateToUsers = function (originalUsers) {
        var selectUserFromTaskTemplate = {
            id: guid.empty,
            name: "".concat(intl.formatMessage(messages.UserDefinedInTaskTemplate)),
        };
        return __spreadArray([selectUserFromTaskTemplate], originalUsers, true);
    };
    var _g = useState(appendUserFromTaskTemplateToUsers(usersFromProps || usersFromDataCache)), users = _g[0], setUsers = _g[1];
    var _h = useState(__assign(__assign({}, defaultTask), { resourceId: defaultCompany.defaultTaskResourceId })), task = _h[0], setTask = _h[1];
    var _j = useState(), resources = _j[0], setResources = _j[1];
    var form = createRef();
    var _k = useState(false), touchedTaskName = _k[0], setTouchedTaskName = _k[1];
    var _l = useState(false), touchedRelation = _l[0], setTouchedRelation = _l[1];
    var _m = useState(false), touchedTaskTemplate = _m[0], setTouchedTaskTemplate = _m[1];
    var _o = useState(false), touchedResource = _o[0], setTouchedResource = _o[1];
    var _p = useState(false), dateFocused = _p[0], setDateFocused = _p[1];
    var createPlannedTask = useCreatePlannedTask().createPlannedTask;
    var _q = useState(true), isTaskTemplate = _q[0], setIsTaskTemplate = _q[1];
    useEffect(function () {
        retrieveResources(intl, 0).then(function (response) {
            setResources(response);
        });
    }, [intl]);
    var saveTask = function () { return __awaiter(void 0, void 0, void 0, function () {
        var model;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if ((isTaskTemplate && !task.templateId) ||
                        (!isTaskTemplate && !task.name) ||
                        !task.relation ||
                        !task.relation.invoiceStreamId ||
                        !task.resourceId ||
                        isBeforeMinimum(task.deadline)) {
                        return [2 /*return*/];
                    }
                    model = __assign({}, task);
                    model.deadline = moment.utc(model.deadline);
                    model.taskLevel = 0; // This modal only creates main-tasks when no template was selected, or the backend will set the tasklevel correctly when a task template was selected
                    if (model.userId === guid.empty)
                        model.userId = null; // map user from task template to null (will be configured in backend)
                    if (model.tags.length === 0)
                        model.tags = null;
                    return [4 /*yield*/, createPlannedTask(model)];
                case 1:
                    _a.sent();
                    onSave();
                    return [2 /*return*/];
            }
        });
    }); };
    var closeModal = function () {
        onClose();
    };
    var deadlineChanged = function (deadline) {
        setTask(__assign(__assign({}, task), { deadline: deadline }));
    };
    var userChanged = function (user) {
        setTask(__assign(__assign({}, task), { userId: user ? user.id : null }));
    };
    var relationChanged = function (relation) {
        setTouchedRelation(true);
        var invoiceStream = getFirstSelectedInvoiceStream(relation);
        setTask(__assign(__assign({}, task), { invoiceStreamId: invoiceStream === null || invoiceStream === void 0 ? void 0 : invoiceStream.id, relationId: relation ? relation.id : undefined, relation: relation, assignmentTemplateId: invoiceStream === null || invoiceStream === void 0 ? void 0 : invoiceStream.assignmentTemplateId }));
    };
    var onInvoiceStreamChanged = function (invoiceStreamId) {
        var _a, _b, _c;
        setTask(__assign(__assign({}, task), { invoiceStreamId: invoiceStreamId, assignmentTemplateId: invoiceStreamId
                ? (_c = (_b = (_a = task.relation) === null || _a === void 0 ? void 0 : _a.invoiceStreams) === null || _b === void 0 ? void 0 : _b.find(function (x) { return x.id === invoiceStreamId; })) === null || _c === void 0 ? void 0 : _c.assignmentTemplateId
                : null }));
    };
    var onTaskTemplateChanged = function (template) {
        var _a;
        setTouchedTaskTemplate(true);
        setTask(__assign(__assign({}, task), { templateId: template === null || template === void 0 ? void 0 : template.key, resourceId: (_a = template === null || template === void 0 ? void 0 : template.resourceId) !== null && _a !== void 0 ? _a : defaultCompany.defaultTaskResourceId }));
    };
    var taskNameChanged = function (name) {
        setTouchedTaskName(true);
        setTask(__assign(__assign({}, task), { name: name }));
    };
    var onResourceChanged = function (resource) {
        setTouchedResource(true);
        if (resource === undefined)
            return;
        setTask(__assign(__assign({}, task), { resourceId: resource === null || resource === void 0 ? void 0 : resource.id }));
    };
    var onSetIsTaskTemplate = function (isTemplate) {
        setIsTaskTemplate(isTemplate);
        setTask(__assign(__assign({}, task), { userId: isTemplate ? guid.empty : AuthService.getUserId() }));
    };
    var onTagsChanged = function (tags) {
        setTask(__assign(__assign({}, task), { tags: tags.map(function (x) { return ({
                id: x,
            }); }) }));
    };
    var findSelectedUser = function (userId) { return (users ? users.find(function (x) { return x.id === userId; }) : null); };
    var selectedUser = findSelectedUser(task.userId);
    var taskNameClassName = classNames('form-group', {
        'has-error': touchedTaskName && !task.name,
    });
    var relationClassName = classNames('form-group', {
        'has-error': touchedRelation && (!task.relation || !task.relation.invoiceStreamId),
    });
    var taskTemplateClassName = classNames('form-group', {
        'has-error': touchedTaskTemplate && !task.templateId,
    });
    var taskResourceClassName = classNames('form-group', {
        'has-error': touchedResource && !task.resourceId,
    });
    return (_jsx(OkCancelModal, __assign({ title: intl.formatMessage(messages.AddOneTimeTask), show: show, onClose: closeModal, disabled: false, onSave: saveTask }, { children: show && (_jsx("form", __assign({ ref: form }, { children: _jsxs("div", __assign({ className: "form-horizontal" }, { children: [_jsxs("div", __assign({ className: "form-group" }, { children: [_jsx("label", __assign({ className: "control-label col-sm-4" }, { children: intl.formatMessage(messages.UseTaskTemplate) })), _jsx("div", __assign({ className: "col-sm-6" }, { children: _jsx(Toggle, { checked: isTaskTemplate, onChange: function (e) { return onSetIsTaskTemplate(e.target.checked); } }) }))] })), _jsxs("div", __assign({ className: relationClassName }, { children: [_jsx("label", __assign({ className: "control-label col-sm-4" }, { children: intl.formatMessage(messages.Relation) })), _jsx("div", __assign({ className: "col-sm-6 " }, { children: _jsx(RelationSearch, { onChange: relationChanged, changeOnInit: true, initialSelectedItem: initialRelationId ? { key: initialRelationId } : undefined }) }))] })), task.relation && task.relation.invoiceStreams.length > 1 ? (_jsxs("div", __assign({ className: "form-group" }, { children: [_jsx("label", __assign({ className: "control-label col-sm-4" }, { children: intl.formatMessage(messages.Assignment) })), _jsx("div", __assign({ className: "col-sm-6 " }, { children: _jsx(InvoiceStreamSelect, { onChange: onInvoiceStreamChanged, initialValue: task.invoiceStreamId, invoiceStreams: task.relation.invoiceStreams }) }))] }))) : null, isTaskTemplate ? (_jsxs("div", __assign({ className: taskTemplateClassName }, { children: [_jsx("label", __assign({ className: "control-label col-sm-4" }, { children: intl.formatMessage(messages.Task) })), _jsx("div", __assign({ className: "col-sm-6 " }, { children: _jsx(TaskTemplateSelect, { useTemplateInCallback: true, onChange: onTaskTemplateChanged, placeholder: intl.formatMessage(messages.Task), includeWithoutTemplate: false }) }))] }))) : (_jsxs("div", __assign({ className: taskNameClassName }, { children: [_jsx("label", __assign({ className: "control-label col-sm-4" }, { children: intl.formatMessage(messages.Description) })), _jsx("div", __assign({ className: "col-sm-6" }, { children: _jsx("input", { type: "text", autoFocus: true, value: task.name, placeholder: intl.formatMessage(messages.Description), onChange: function (e) { return taskNameChanged(e.target.value); }, required: true, className: "form-control" }) }))] }))), _jsxs("div", __assign({ className: classNames('form-group', {
                            'has-error': isBeforeMinimum(task.deadline),
                        }) }, { children: [_jsx("label", __assign({ className: "control-label col-sm-4" }, { children: intl.formatMessage(messages.Deadline) })), _jsx("div", __assign({ className: "col-sm-6" }, { children: _jsx(DatePicker, { placeholder: intl.formatMessage(messages.Deadline), date: task.deadline, onDateChange: deadlineChanged, focused: dateFocused, onFocusChange: function (_a) {
                                        var focused = _a.focused;
                                        return setDateFocused(focused);
                                    }, id: "todoDeadline", block: true, small: true, isOutsideRange: falseFunc, phrases: {}, numberOfMonths: 1 }) }))] })), _jsxs("div", __assign({ className: "form-group" }, { children: [_jsx("label", __assign({ className: "control-label col-sm-4" }, { children: intl.formatMessage(messages.AssignedTo) })), _jsx("div", __assign({ className: "col-sm-6" }, { children: _jsx(UserSearch, { users: users, onChange: userChanged, value: selectedUser }) }))] })), _jsxs("div", __assign({ className: taskResourceClassName }, { children: [_jsx("label", __assign({ className: "control-label col-sm-4" }, { children: intl.formatMessage(messages.PriceListItem) })), _jsx("div", __assign({ className: "col-sm-6" }, { children: _jsx(ResourceAutoComplete, { items: resources, placeholder: intl.formatMessage(messages.PriceListItem), onChange: onResourceChanged, emptyLabel: intl.formatMessage(messages.NoPriceListItemsFound), value: { id: task.resourceId }, crmType: (_b = task.relation) === null || _b === void 0 ? void 0 : _b.crm, assignmentTemplateId: task.assignmentTemplateId, required: true, intl: intl, disabled: false, small: false }) }))] })), _jsxs("div", __assign({ className: "form-group" }, { children: [_jsx("label", __assign({ className: "control-label col-sm-4" }, { children: intl.formatMessage(messages.Tags) })), _jsx("div", __assign({ className: "col-sm-6" }, { children: _jsx(TaskTagsMultiSelect, { allowNew: true, selection: task.tags.map(function (x) { return x.id; }), onChange: onTagsChanged }) }))] })), _jsxs("div", __assign({ className: "form-group" }, { children: [_jsx("label", __assign({ className: "control-label col-sm-4" }, { children: intl.formatMessage(messages.Remark) })), _jsx("div", __assign({ className: "col-sm-6" }, { children: _jsx("textarea", { id: "RemarkField", className: "form-control input-sm vertical-resize", value: task.remark, maxLength: 4000, onChange: function (e) {
                                        return setTask(__assign(__assign({}, task), { remark: e.target.value }));
                                    } }) }))] }))] })) }))) })));
};
export default CreateOneTimeTask;
